import { loadable } from '@shared/core/loadableFromNamedExport';

export const CustomerReviewsV2Lazy = loadable(() => import('./CustomerReviewsV2'), 'CustomerReviewsV2');
